<template>
  <div class="password-reset-request-form">
    <NotificationBanner
      v-if="isSuccess & !isError"
      :message="
        $t('password-reset.request-succeeded-message', { email: formEmail })
      "
      is-success
    />

    <template v-else>
      <NotificationBanner
        v-if="isError"
        :message="$t('password-reset.request-failed-error')"
        is-danger
      />

      <form autocomplete="off" spellcheck="false" @submit.prevent="submit">
        <FormTextInput
          v-model="formEmail"
          name="email"
          type="email"
          :label="$t('field-labels.email')"
          :is-disabled="isLoading"
          is-required
        />

        <FormButton :is-busy="isLoading" :is-disabled="formEmail.length < 1">
          {{ $t('password-reset.submit') }}
        </FormButton>
      </form>
    </template>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'

import FormButton from '@/components/common/FormButton.vue'
import FormTextInput from '@/components/common/FormTextInput.vue'
import NotificationBanner from '@/components/common/NotificationBanner.vue'
import PasswordReset from '@/utils/password-reset'

/* local state */

const formEmail = ref<string>('')
const isError = ref<boolean>(false)
const isLoading = ref<boolean>(false)
const isSuccess = ref<boolean>(false)

/* actions */

const submit = async (): Promise<void> => {
  isLoading.value = true

  const isRequestSuccessful = await PasswordReset.requestToken(
    formEmail.value ?? '',
  )

  isSuccess.value = isRequestSuccessful
  isError.value = !isRequestSuccessful
  isLoading.value = false
}
</script>

<style lang="scss" scoped>
@import 'src/assets/scss/globals';

.password-reset-request-form,
.password-reset-request-form > form {
  display: flex;
  flex-flow: column nowrap;
  gap: 1em;
}
</style>
